import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Card,
    Form,
    Col,
    Divider,
    Spin,
} from "antd";


//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from '../../../components/layouts/MainLayout';
import TopContent from '../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from '../security.config';
import CustomButton from '../../../components/custom/CustomButton';
import TextArea from 'antd/es/input/TextArea';
import { showCheckerApprovalModal } from '../../../components/CheckerModal';

const NewRole = (props) => {
    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);


    function onCancel() {
        navigate("/sms0400", { state: state });
    };

    const onSubmit = (formValues) => {

        const url = `${apiConfig.Roles}`

        const body = {
            ...formValues,
            method: "POST",
            session
        };

        // return
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.newRoleMsg);
                navigate("/detail-role", { state: { id: res.resourceId, key: res.resourceId, name: formValues.name } });
                
                //STOP LOAD
                setIsLoading(false);
            }
        },{
                navigate,
                showCheckerModal: showCheckerApprovalModal,
                onCheckerApproval: (res) => {
                navigate("/sms0400");
                  setIsLoading(false);
                },
              });
    };

    return (

        <MainLayout isEnableRightSidebar={true} >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.newRole}
                pageItems={staticConfig.newRoleBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}

                >
                    <Form
                        form={useForm}
                        layout="vertical"
                        onFinish={onSubmit}
                    >

                        <Row>
                            {/* DETAILS  */}
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.name}
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.name
                                            ),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                                    />
                                </Form.Item>
                            </Col>

                            <Divider />

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.description}
                                    name={"description"}
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.name
                                            ),
                                        },
                                    ]}
                                >
                                    <TextArea style={{ width: "100%", height: "10vh" }} placeholder='Please Enter a Description' />

                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Divider />
                            {BOM.HasPermission("CREATE_STAFF") && <CustomButton
                                content="Submit"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#92428B"
                                colorText="white"
                                hoverBackground="#AD4EA7"
                            />}

                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>

                </Card>
            </Spin>

        </MainLayout>
    )
}

export default NewRole